import * as ko from "knockout";

ko.components.register('table-header-cell', {
	viewModel: function (params) {
		var self = this;
		self.show_visibility_toggle = ko.observable(params.show_visibility_toggle ?? true);
		self.visibility_var = params.visibility_var || ko.observable(true);
		self.label_prefix = ko.observable(params.label_prefix || undefined);
		self.label = ko.observable(params.label);
		self.show_sort = ko.observable(params.show_sort || false);
		self.sort_onclick = params.sort_onclick;
		self.sort_visible = params.sort_visible;
		self.sort_visible_var = params.sort_visible_var;
		self.sort_asc = params.sort_var || ko.observable();
		self.sort_desc = ko.pureComputed(() => !self.sort_asc());

		self.popoverLabel = ko.pureComputed(() => {
			if (!self.show_visibility_toggle()) return ''
			return self.label_prefix() ? `${self.label_prefix()} ${self.label()}` : `${self.label()}`
		});
	},
	template:
		`<div class="d-flex gap-1 lh-sm">
			<!-- ko if: show_visibility_toggle() -->
			<div class="text-primary mdi opacity-50-hover align-self-center" style="cursor: pointer;" data-bs-toggle="popover"
				data-bs-trigger="hover focus" data-bind="
					popoverTitle: '',
					popover: popoverLabel,
					click: () => {visibility_var(!visibility_var())},
					css: {
						'mdi-eye-off': !visibility_var(),
						'mdi-eye': visibility_var(),
					}
			"></div>
			<!-- /ko -->
			<!-- ko if: visibility_var -->
			<!-- ko if: label_prefix -->
			<div class="flex-grow-1" data-bind="text: label_prefix"></div>
			<!-- /ko -->
			<div class="d-flex gap-1 flex-grow-1 justify-content-center" data-bind="
				style: {cursor: show_sort() ? 'pointer' : null },
				click: sort_onclick
			">
				<div data-bind="text: label, css: {'text-decoration-underline': show_sort}"></div>
				<!-- ko if: show_sort -->
				<div class="text-primary mdi align-self-center" data-bind="
					visible: sort_visible_var() === sort_visible,
					css: {
						'mdi-arrow-up-bold': sort_asc,
						'mdi-arrow-down-bold': sort_desc
					}
				"></div>
				<!-- /ko -->
			</div>
			<!-- /ko -->
		</div>`
});